import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NEW_DASHBOARD_TEMPLATE_ID } from "../constants";
var translation = /*#__PURE__*/_defineProperty({}, NEW_DASHBOARD_TEMPLATE_ID, {
  GENERAL_ERROR: 'An error occurred',
  TRY_AGAIN: 'Try again',
  SEARCH_LABEL: 'What are you looking for in your dashboard?',
  INTERNET_CONNECTION_ERROR: 'A connection error occurred',
  RELOAD_PAGE: 'Reload the page',
  BUTTON_COLLAPSE_SIDEBAR_OPENED: 'Collapse menu',
  BUTTON_COLLAPSE_SIDEBAR_CLOSED: 'Expand menu',
  GO_TO_OLD_HOME_SNACKBAR_CTA: 'Go back to the old version',
  PRODUCT: 'Product'
});
export default translation;